<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-row v-auth-acl="'gh-okr-mat_seg-read'">
      <v-col cols="12" sm="12">
        <BaseCard>
          <MatrizLista></MatrizLista>
        </BaseCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'MatrizSeguimiento',
  components: {
    MatrizLista: () => import('../components/MatrizLista')
  },
  data: () => ({
    page: {
      title: 'OKR'
    },
    breadcrumbs: [
      {
        text: 'OKR',
        disabled: true
      },
      {
        text: 'Matriz de Seguimiento',
        disabled: false
      }
    ]
  }),
  methods: {
    open() {},
    close() {}
  }
};
</script>
